/* eslint-disable no-console, import/default */
import './env';
import buildSubscriber from './build_subscriber';
// import Worker from './engage.worker.js' // eslint-disable-line import/default

export let registration;

const is_bad_chrome = (() => {
    const chrome_match =
        'navigator' in global && navigator.userAgent.match(/Chrome\/(\d{2})/);
    return chrome_match && Number(chrome_match[1]) < 66;
})();

if (is_bad_chrome) {
    console.warn(
        'Your version of Chrome may crash with offline enabled.',
        'To prevent this, Engage service worker will be disabled and you will not be able to use Chrome offline.',
        'Please upgrade your browser or use Mozilla Firefox to use Engage while offline.'
    );
}

const secureOrigin =
    // TODO what is polyfilling global = window?
    'location' in global && // location doesn't exist in node
    (window.location.protocol === 'https:' ||
        window.location.hostname === 'localhost');

export const canUseServiceWorker =
    !is_bad_chrome &&
    secureOrigin &&
    'localStorage' in global &&
    'navigator' in global &&
    'serviceWorker' in navigator;

export const swEnabled =
    !is_bad_chrome &&
    canUseServiceWorker &&
    process.env.REACT_APP_OFFLINE &&
    localStorage.getItem('QUOTA_FAILURE-2016-09-01') == null;

export const STORAGE_KEY = 'engage-state-v2';
export const OLD_KEYS = ['engage-state-v1'];

export function swCommand(commandName, ...args) {
    if (navigator.serviceWorker.controller == null) {
        return;
    }
    navigator.serviceWorker.controller.postMessage({
        type: 'SW_COMMAND',
        commandName,
        args,
    });
}

const { subscribe: subscribeToMessages, emit: emitMessage } = buildSubscriber();

export { subscribeToMessages };

export function uninstallSW() {
    navigator.serviceWorker.addEventListener('message', emitMessage);
    swCommand('uninstall');
}

// including `process.env.OFFLINE` here allows dead code elemination to strip
// this code and the `require()` from builds where offline is disabled.
if (process.env.REACT_APP_OFFLINE && swEnabled) {
    const runtime = require('serviceworker-webpack-plugin/lib/runtime');
    // const registration = runtime.register();
    runtime.register();
    navigator.serviceWorker.addEventListener('message', emitMessage);
    // TODO: get this back in
    // .catch((err) => {
    //     console.error('registration failed', err) // eslint-disable-line no-console
    //     throw err
    // })
} else if (canUseServiceWorker) {
    navigator.serviceWorker.getRegistration().then(function(r) {
        if (r != null) {
            uninstallSW();
        }
    });
}



// WEBPACK FOOTER //
// ./src/engage_cache.js